import React, { FunctionComponent } from 'react';
import { HealthInsuranceSelect, IHealthInsuranceEntry } from 'View/Component';
import { Bold, Col, Headline, HR, Paragraph, Row, Link } from 'View/Common';
import { useGetOffers } from '../../HookApi/useGetOffers';
import { StyledRoundedBox } from './HealthInsuranceSelectionBox.style';

interface IProps {
  healthInsurance?: IHealthInsuranceEntry | null;
  onChange?: (healthInsurance: IHealthInsuranceEntry | null) => void;
  onReset?: () => void;
}
export const HealthInsuranceSelectionBox: FunctionComponent<IProps> = ({ healthInsurance, onChange }) => {
  const { offers } = useGetOffers();
  const zppOffer = offers.zpp;

  const handleOnSetHealthInsurance = (healthInsurance: IHealthInsuranceEntry) => {
    onChange && onChange(healthInsurance);
  };

  const handleOnResetHealthInsurance = () => {
    onChange && onChange(null);
  };

  const getReduction = (reductionRate: number | undefined) => {
    const price = zppOffer?.price?.cents || 0;
    if (reductionRate) {
      return ((price * reductionRate) / 10000).toFixed(2);
    }
    return '0,00';
  };

  const getPayablePart = (reductionRate: number | undefined) => {
    const price = zppOffer?.price?.cents || 0;

    if (reductionRate) {
      return ((price - price * (reductionRate / 100)) / 100).toFixed(2);
    }
    return (price / 100).toFixed(2);
  };

  if (!healthInsurance) {
    return (
      <>
        <Headline level={2}>Mach jetzt den Erstattungs-Check:</Headline>
        <Paragraph>
          Sichere dir den Präventionskurs "Erholsamen Schlaf finden – ein App-gestützter Online-Kurs" und 12 Monate Zugang zur gesamten
          7Schläfer App.
        </Paragraph>
        <Paragraph>Wie hoch ist deine Erstattung?</Paragraph>
        <HealthInsuranceSelect onChange={handleOnSetHealthInsurance} />
      </>
    );
  }

  if (healthInsurance.cooperationPartner) {
    return (
      <>
        <Headline level={2}>Fantastisch!</Headline>
        <Paragraph>
          <Bold>Für Versicherte der {healthInsurance?.name} gibt es ein kostenfreies Angebot. Du kannst ohne Vorauszahlung loslegen. </Bold>
          Kein Abo, keine Kündigung notwendig.
        </Paragraph>
        <Link title="Krankenkasse ändern" onClick={handleOnResetHealthInsurance}>
          Krankenkasse ändern
        </Link>
      </>
    );
  }

  return (
    <>
      <Headline level={2}>Wie schön!</Headline>
      <Paragraph>
        <Bold>
          {healthInsurance?.name} Versicherte bekommen {healthInsurance?.reductionRate}% der Kosten für dieses Angebot erstattet. Achte
          darauf, den Kurs in 6 Monaten abzuschließen. <br />
        </Bold>
        Kein Abo, keine Kündigung notwendig.
      </Paragraph>
      <Link title="Krankenkasse ändern" onClick={handleOnResetHealthInsurance}>
        Krankenkasse ändern
      </Link>
      <br />
      <br />
      <StyledRoundedBox>
        <Row className="card-head">
          <Paragraph className="bold">{`Erstattung ${healthInsurance?.reductionRate} %`}</Paragraph>
        </Row>
        <Row>
          <Col xs={9}>
            <Paragraph>Preis für zwölf Monate (Vorleistung)</Paragraph>
          </Col>
          <Col xs={3}>
            <Paragraph className="price text-right">{zppOffer?.price?.localizedPrice}</Paragraph>
          </Col>
          <Col xs={9}>
            <Paragraph>Erstattung {healthInsurance?.reductionRate}% (Nach Kurs-Absolvierung)</Paragraph>
          </Col>
          <Col xs={3} className="test">
            <Paragraph className="price text-right">- {getReduction(healthInsurance?.reductionRate)} €</Paragraph>
          </Col>
          <HR />
          <Col xs={9}>
            <Paragraph className="bold">Dein Anteil</Paragraph>
          </Col>
          <Col xs={3} id="erstattungscheck-box">
            <Paragraph className="bold price text-right">{getPayablePart(healthInsurance?.reductionRate)} €</Paragraph>
          </Col>
        </Row>
      </StyledRoundedBox>
    </>
  );
};
